import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import React from 'react';
import Loading from './../misc/Loading';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import PublishStatusTableRow from '../table/PublishStatusTableRow.js';
import './Campaigns.scss';

function campaignDateIsValid(fromDate, toDate) {
  let active = true;
  const now = new Date();

  if (fromDate > now) {
    active = false;
  } else if (toDate < now) {
    active = false;
  }

  return active;
}

export function printCampaignVisibility(campaign) {
  const icons = [];

  const dateValid = campaignDateIsValid(campaign.startDate, campaign.expiryDate);
  const published = campaign.published;
  const hasMakes = campaign.makes && campaign.makes.length > 0;
  const isMotorforumOverride = campaign.mfRotationOverride;

  if (published && dateValid && (hasMakes || isMotorforumOverride)) {
    icons.push(<i
      className="fa fa-check text-success"
      key="campaignStatusIcon1"
      aria-hidden="true"
      title="Synlig på nett"
    ></i>);
    icons.push('\u00a0'); // &nbsp;
  } else {
    icons.push(<i
      className="fa fa-times text-danger"
      key="campaignStatusIcon2"
      aria-hidden="true"
      title="Ikke synlig på nett"
    ></i>);
    icons.push('\u00a0'); // &nbsp;
  }

  if (!dateValid) {
    icons.push(<i
      className="fa fa-calendar-times-o text-danger"
      key="campaignStatusIcon3"
      aria-hidden="true"
      title="Utenfor publiseringstidsrom"
    ></i>);
    icons.push('\u00a0'); // &nbsp;
  }

  if (!published) {
    icons.push(<i
      className="fa fa-upload text-danger"
      key="campaignStatusIcon4"
      aria-hidden="true"
      title="Ikke publisert"
    ></i>);
    icons.push('\u00a0'); // &nbsp;
  }

  if (!hasMakes && !isMotorforumOverride) {
    icons.push(<i
      className="fa fa-car text-danger"
      key="campaignStatusIcon5"
      aria-hidden="true"
      title="Ikke publisert til noen merker"
    ></i>);
    icons.push('\u00a0'); // &nbsp;
  }

  return icons;
}

class Campaigns extends React.Component {
  printMakes(makes) {
    let makesString = '';
    if (makes) {
      // console.log(dealer.makes);
      makesString += makes.map((make) => {
        return make.name;
      });
    }
    return makesString;
  }

  printFilterButton() {
    const boxFilterBtnDisabled = this.props.campaigns.length === 0 && this.props.filter === null;

    return (
      <div className="btn-group" role="group">
        <div className="dropdown">
          <button
            type="button"
            data-toggle="dropdown"
            className={`btn btn-default dropdown-toggle${boxFilterBtnDisabled ? ' disabled' : ''}`}
            disabled={this.props.working}
          >
            Merke: <strong>{this.selectedMakeName || 'Alle'}</strong> <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" >
            <li className={this.props.filter === null ? 'active' : ''}>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                this.props.handleFilterChange(null);
              }}>
                Alle
              </a>
            </li>
            <li role="separator" className="divider"></li>
            {this.props.makes.map((make, i) => {
              return (
                <li key={`make-${i}`} className={this.props.filter === make.id ? 'active' : ''}>
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.props.handleFilterChange(make.id);
                  }}>
                    {make.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  printButtonGroup() {
    return (
      <div className="pull-right">
        {this.props.working &&
          <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
        }
        {this.props.handleToggleShowArchived &&
          <button
            className="btn btn-info"
            disabled={this.props.working}
            onClick={(e) => {
              e.preventDefault();
              this.props.handleToggleShowArchived();
            }}>
            {this.props.showArchived ? 'Gjem arkiverte kampanjer' : 'Vis arkiverte kampanjer'}
          </button>
        }
        &nbsp;
        {this.printFilterButton()}
        &nbsp;
        &nbsp;
        <Link
          to={'/campaigns/new'}
          className="btn btn-success"
          disabled={this.props.working}
        >
          Ny kampanje
        </Link>
      </div>
    );
  }

  printPager() {
    if (!this.props.campaigns.length) {
      return;
    }

    if (!this.props.total || this.props.total <= this.props.limit) {
      return;
    }

    const pages = Math.ceil(this.props.total / this.props.limit);
    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * this.props.limit);
    }

    const lastOffset = offsets[offsets.length - 1];

    if (this.props.total && this.props.total > this.props.limit) {
      return <ul className="pagination">
        <li className={(this.props.offset === 0 || this.props.working) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.handleSetOffset(0);
            }}
            aria-label="Previous"
            disabled={this.props.working}
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        {offsets.map((offset, i) => {
          return <li key={`page-${i}`} className={this.props.offset === offset ? 'active' : (this.props.working ? ' disabled' : '')}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleSetOffset(offset);
              }}
              disabled={this.props.working}
            >
              {i + 1}
            </a>
          </li>;
        })}

        <li className={((this.props.offset + this.props.limit) > this.props.total || this.props.working) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.handleSetOffset(lastOffset);
            }}
            aria-label="Next"
            disabled={this.props.working}>
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>;
    }
  }

  printCampaignType(campaignType) {
    const types = {
      'newcar': 'Nybil',
      'newcar-loan': 'Rente',
      'newcar-fixed-rate-loan': 'Fastrente',
      'parts': 'Tilbehør',
      'service': 'Service',
      'reservation': 'Reservasjon'
    };

    return types[campaignType] || campaignType;
  }

  render() {
    this.selectedMakeName = null;
    if (this.props.filter) {
      this.props.makes.forEach((make) => {
        if (make.id === this.props.filter) {
          this.selectedMakeName = make.name;
        }
      });
    }

    if (this.props.campaigns) {
      if (this.props.campaigns.length !== 0) {
        let sortIconClass;
        let sortType;
        let priClickSort = '-fields.priority';
        let typeClickSort = 'fields.type';

        switch (this.props.sort) {
          case 'fields.priority':
            sortIconClass = 'fa-arrow-up';
            sortType = 'pri';
            break;
          case '-fields.priority':
            sortIconClass = 'fa-arrow-down';
            priClickSort = 'fields.priority';
            sortType = 'pri';
            break;
          case 'fields.type':
            sortIconClass = 'fa-arrow-up';
            typeClickSort = '-fields.type';
            sortType = 'type';
            break;
          case '-fields.type':
            sortIconClass = 'fa-arrow-down';
            sortType = 'type';
            break;
        }

        return (
          <section className="campaign mf-padding-top-20">
            <ol className="breadcrumb">
              <li><Link to="/">Forsiden</Link></li>
              <li className="active">Kampanjer</li>
            </ol>

            <div className="page-header">
              {this.printButtonGroup()}
              <h1>Kampanjer {this.selectedMakeName && <small>({this.selectedMakeName})</small>}</h1>
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th title="Publiseringsstatus"></th>
                    <th>Tittel</th>
                    <th>Intern Sammendrag</th>
                    <th>Synlig?</th>
                    <th>Til - fra</th>
                    <th>
                      <a href="#" onClick={() => this.props.handleSort(priClickSort)}>
                        Pri{sortType === 'pri' && sortIconClass && <i className={`fa ${sortIconClass}`} aria-hidden="true"></i>}
                      </a>
                    </th>
                    <th>
                      <a href="#" onClick={() => this.props.handleSort(typeClickSort)}>
                        Type{sortType === 'type' && sortIconClass && <i className={`fa ${sortIconClass}`} aria-hidden="true"></i>}
                      </a>
                    </th>
                    <th>Merke(r)</th>
                    <th>Modell</th>
                    <th title="Forhandlere">#</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.campaigns.map((campaign) => {
                    return (
                      <PublishStatusTableRow entry={campaign} key={`campaign-${campaign.id}`}>
                        <td className="text-center" title="Publiseringsstatus">
                          <PublishStatusDot entry={campaign} />
                        </td>
                        <td>
                          <Link to={`/campaigns/${campaign.id}`}>{campaign.name}</Link>
                        </td>
                        <td>
                          {campaign.summary}
                        </td>
                        <td className="text-center">
                          {printCampaignVisibility(campaign)}
                        </td>
                        <td>
                          {campaign.startDate.toLocaleDateString('nb')} - {campaign.expiryDate.toLocaleDateString('nb')}
                        </td>
                        <td>
                          {campaign.priority}
                        </td>
                        <td>
                          {this.printCampaignType(campaign.type)}
                        </td>
                        <td>
                          {this.printMakes(campaign.makes)}
                        </td>
                        <td>
                          {campaign.model &&
                            <span>{campaign.model.name}</span>
                          }
                        </td>
                        <td className="text-center" title="Forhandlere">
                          {campaign.dealers &&
                            <span className="badge">{campaign.dealers.length}</span>
                          }
                        </td>
                      </PublishStatusTableRow>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="text-center">
              {this.printPager()}
            </div>
          </section>
        );
      }
      return (
        <section className="campaign mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li className="active">Kampanjer</li>
          </ol>

          <div className="page-header">
            {this.printButtonGroup()}
            <h1>Kampanjer</h1>
          </div>

          <div className="alert alert-warning">
            <p>
              Fant ingen kampanjer
            </p>
          </div>
        </section>
      );
    }
    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li className="active">Kampanjer</li>
        </ol>
        <Loading title="Kampanjer" text="Laster kampanjer"/>
      </section>
    );
  }
}

Campaigns.defaultProps = {
};

export default withRouter(Campaigns);
